<template>
  <div>
    <div
      v-if="liquidation"
      @click.stop.prevent="liquidationView"
      class="sale-document-body md__border border-radius bg-color-write p-3 mb-2 cursor-point"
      :class="{ 'signing-card--active': isSigning }"
    >
      <div class="sale-document-info">
        <div class="sale-document-description d-flex justify-content-between">
          <div class="info">
            <p class="m-0 text-color-primary str-limit-space">
              N° {{ liquidation.number_liquidation }}
            </p>
            <p class="m-0 font-bold text-color-primary str-limit-space">
              {{ liquidation.client.name }}
            </p>
          </div>
          <div class="sale-document-number">
            <h5 class="h5 font-bold">
              <FormatAmount :amount="liquidation.total" />
            </h5>
            <span class="card-date">{{
              formatFullDate(liquidation.created_at)
            }}</span>
          </div>
        </div>
      </div>

      <div
        class="sale-document-actions d-flex justify-content-between align-items-center mt-4"
      >
        <div class="status d-flex">
          <template v-if="isSigning">
            <span class="signing-badge">
              <span class="signing-badge__spinner"></span>
              Firmando...
            </span>
          </template>
          <template v-else>
            <StatusReadDocumentsComponent
              :status.sync="liquidation.status"
              typeStatus="short"
            />
            <CheckSuccessfully
              class="ml-2"
              :success="liquidation.is_paid"
              text="Pagada"
            />
          </template>
        </div>
        <div class="next" @click.stop>
          <LiquidationOptionsByStatus
            :status="liquidation.status"
            :id="liquidation.id"
            :is_paid="liquidation.is_paid"
            @goPage="goRouter"
            @onSigningStart="isSigning = true"
            @onSigningDone="onSigningDone"
            @onSigningError="isSigning = false"
            @onDocDeleted="id => $emit('onDocDeleted', id)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusReadDocumentsComponent from "../../../../components/StatusReadDocuments";
import CheckSuccessfully from "@/components/General/CheckSuccessfully";
import FormatAmount from "@/components/General/FormatAmount";
import LiquidationOptionsByStatus from "./LiquidationOptionsByStatus";

export default {
  name: "LiquidationCardComponent",
  data() {
    return {
      showDialogPayLink: false,
      paymentLink: null,
      showEnablePaylink: false,
      isSigning: false
    };
  },
  computed: {
    isStatusNuled() {
      return this.liquidation.status === "nuled";
    },
    isShowPayLink() {
      return !this.isStatusNuled && !this.liquidation?.is_paid;
    }
  },
  methods: {
    formatFullDate(date) {
      if (!date) return "";
      const normalized = /^\d{4}-\d{2}-\d{2}$/.test(date) ? date + "T00:00:00" : date;
      const d = new Date(normalized);
      const months = [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ];
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    onSigningDone({ id, data }) {
      this.isSigning = false;
      if (data) this.$emit("onDocUpdate", { id, data });
    },
    liquidationView() {
      this.goRouter("sales.liquidations.view", {
        id: this.liquidation.id
      });
    },
    onDialogPayLinkClose() {
      this.showDialogPayLink = false;
    },
    onClosePaymentUpDoc() {
      this.showEnablePaylink = false;
    }
  },
  components: {
    StatusReadDocumentsComponent,
    CheckSuccessfully,
    FormatAmount,
    LiquidationOptionsByStatus
  },
  props: {
    liquidation: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.signing-card--active {
  opacity: 0.45;
  pointer-events: none;
  transition: opacity 0.2s ease;
}
.signing-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 500;
  color: #534ab7;
  background: #eeedfe;
  border-radius: 10px;
  padding: 2px 8px;
  &__spinner {
    width: 10px;
    height: 10px;
    border: 1.5px solid #eeedfe;
    border-top-color: #534ab7;
    border-radius: 50%;
    animation: signing-card-spin 0.7s linear infinite;
  }
}
@keyframes signing-card-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
